var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, CircularProgress } from '@mui/material';
export function LoadingModal(_a) {
    var isLoading = _a.isLoading;
    return (_jsx(Backdrop, __assign({ sx: {
            zIndex: function (theme) { return theme.zIndex.drawer + 1; },
        }, open: isLoading }, { children: _jsx(CircularProgress, {}) })));
}
